module.exports = __webpack_public_path__ + "img/theHUB-logo-wh.d83ca926.png";